var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronThinRight = function SvgChevronThinRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 15.6 9.774 3.728a1.114 1.114 0 0 1 0-1.566 1.09 1.09 0 0 1 1.55 0l12.528 12.653a1.114 1.114 0 0 1 0 1.566L11.324 29.034a1.087 1.087 0 0 1-1.55 0 1.114 1.114 0 0 1 0-1.566z"
  })));
};
export default SvgChevronThinRight;